import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRCON_AUT_PDF;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
